// src/pages/LegacyDashboard.jsx
import React from "react";
import { BASE_URL } from "../utils";
import ModuleDashboard from "../components/ModuleDashboard";

export default function LegacyDashboard() {
  return (
    <ModuleDashboard
      moduleKey="LG"
      eyebrow="Legacy Workspace"
      title="Legacy Dashboard"
      subtitle="Overview of Approved, Rejected, and Processing legacy cases"
      sectionTitle="Legacy"
      sectionSubtitle="Live data from the Legacy system"
      fetchUrl={`${BASE_URL}/api/legacy/dashboard-summary`}
      totalLabel="cases"
      showWorkingBadge={false}
    />
  );
}
